import React, { useEffect, useState } from 'react';
import Filters from './Filters';
import TransfersList from './TransfersList';
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import { EMPTY_FILTER_FORM, getAppliedFilterCount, searchTransferRequests, updateTransferRequestsList } from './utils';
import {ReactComponent as BackIcon} from "assets/img/svg/BackArrow.svg";


const StudentTransfersListing = ({
    dropdownData ,
    handleEditTransfer,
    setShowTransferRequestsList
}) => {

    const [transferRequestsInfo, setTransferRequestsInfo] = useState({
        loading: false,
        data: []
    });

    const [paginationInfo, setPaginationInfo] = useState({
        currPageSize: 50,
        currPage: 0,
        totalRecords: 0
    })

    const [filterForm, setFilterForm] = useState(EMPTY_FILTER_FORM);

    const handleFilterForm = (key, value) => setFilterForm(prev => ({ ...prev, [key]: value }))

    const getStudentTransfersList = async ({
        dropdowns = dropdownData?.data,
        filters = filterForm,
        pageNo = paginationInfo?.currPage,
        pageSize = paginationInfo?.currPageSize,
    }) => {
        try {

            setTransferRequestsInfo(prev => ({ ...prev, loading: true }));

            const resp = await searchTransferRequests({ dropdowns, filters, pageNo, pageSize });

            if (resp?.code === 200) {

                const { currentPage, totalRecords, transferDetails } = resp?.data;

                setTransferRequestsInfo(prev => ({
                    ...prev,
                    data: updateTransferRequestsList(transferDetails, dropdowns)
                }))

                setPaginationInfo(prev => ({
                    ...prev,
                    totalRecords,
                    currPage: currentPage,
                    currPageSize: pageSize
                }))

                setFilterForm({
                    ...filters,
                    appliedFilterCount : getAppliedFilterCount(filters, ['psid', 'applicationId', 'studentName', 'status'])
                });
            }

        } catch (err) {
            console.error(err);
        } finally {
            setTransferRequestsInfo(prev => ({ ...prev, loading: false }))
        }

    }

    useEffect(() => {
        Object.keys(dropdownData?.data)?.length > 0 && getStudentTransfersList({});
    }, [dropdownData?.data])

    return (

        <div className='a-card' style={{height:"75vh"}}>

            {(dropdownData?.loading || transferRequestsInfo?.loading) && <ALoader position="fixed" />}

            <div className='d-flex justify-content-between'>

                
                <div className='d-flex'>
                <BackIcon className='mr-2 cursor' onClick={() => setShowTransferRequestsList(false)}/>
                <div className='large-bold color-black'>Transfer Tracker</div>
                </div>

                <Filters
                    dropdownData={dropdownData?.data}
                    handleFilterForm={handleFilterForm}
                    filterForm={filterForm}
                    getStudentTransfersList={getStudentTransfersList}
                />
            </div>

            <TransfersList
                transferRequestsInfo={transferRequestsInfo}
                paginationInfo={paginationInfo}
                getStudentTransfersList={getStudentTransfersList}
                handleEditTransfer = {handleEditTransfer}

            />

        </div>

    );
}

export default StudentTransfersListing;